var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1299 8.34531C5.4899 6.54531 7.1099 5.19531 8.9999 5.19531C10.3499 5.19531 11.4299 5.82531 12.1499 6.81531L13.6799 5.01531C12.5999 3.75531 10.8899 2.94531 8.9999 2.94531C5.8499 2.94531 3.2399 5.28531 2.7899 8.34531H0.899902L4.0499 11.9453L7.1999 8.34531H5.1299ZM13.9499 6.54531L10.7999 10.1453H12.8699C12.4199 11.9453 10.8899 13.2953 8.9999 13.2953C7.6499 13.2953 6.5699 12.6653 5.8499 11.6753L4.3199 13.3853C5.3999 14.7353 7.1099 15.5453 8.9999 15.5453C12.1499 15.5453 14.7599 13.2053 15.2099 10.1453H17.0999L13.9499 6.54531Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularArrow);
export default __webpack_public_path__ + "static/media/circularArrow.94c68987.svg";
export { ForwardRef as ReactComponent };